import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AFFILIATE_STORAGE_KEY, type StoredAttribution } from '@/lib/affiliate-attribution';
import { validateReferralCode } from '@/lib/supabase-marketing';

const EXPIRY_DAYS = 30;

/**
 * Hook to capture and persist affiliate attribution from URL parameters.
 * Call this at the app root to capture attribution on any landing page.
 */
export function useAffiliateTracking() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refCode = searchParams.get('ref');
    if (!refCode) return;

    const validateAndStoreAttribution = async () => {
      try {
        const referralId = await validateReferralCode(refCode);
        if (!referralId) {
          console.log('[AffiliateTracking] Invalid or inactive referral code:', refCode);
          return;
        }

        const now = new Date();
        const expiresAt = new Date(now.getTime() + EXPIRY_DAYS * 24 * 60 * 60 * 1000);

        const attribution: StoredAttribution = {
          affiliateReferralId: referralId,
          referralCode: refCode,
          capturedAt: now.toISOString(),
          expiresAt: expiresAt.toISOString(),
        };

        localStorage.setItem(AFFILIATE_STORAGE_KEY, JSON.stringify(attribution));
        console.log('[AffiliateTracking] Attribution captured:', referralId);
      } catch (err) {
        console.error('[AffiliateTracking] Error:', err);
      }
    };

    validateAndStoreAttribution();
  }, [searchParams]);
}
